module.exports = __webpack_public_path__ + "img/metal_s@2x.094af5fe.png";